export default {
  focus ({ commit }, name)  {
    commit('setFocus', {
      name,
      value: true
    })
  }
}
